<template>
  <div class="content">
    <div class="list_index">
      <el-radio-group
        v-model="data"
        class="radio-left"
        @change="selectChange"
        size="small"
      >
        <el-radio-button label="2">实时趋势图</el-radio-button>
        <el-radio-button label="0">历史趋势图</el-radio-button>
        <el-radio-button label="1">历史数据</el-radio-button>
      </el-radio-group>
      <div>
        <el-select
          v-if="data == '2'"
          class="mt20"
          v-model="time_interval"
          @change="time_intervalChange"
        >
          <el-option value="0" label="10分钟"></el-option>
          <el-option value="1" label="1小时"></el-option>
          <el-option value="2" label="2小时"></el-option>
          <el-option value="3" label="3小时"></el-option>
          <el-option value="4" label="4小时"></el-option>
          <el-option value="5" label="8小时"></el-option>
          <el-option value="6" label="12小时"></el-option>
        </el-select>
      </div>
      <div class="button" v-if="data != '2'">
        <div class="date">
          <span class="text">时间：</span>
          <el-date-picker
            v-model="date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          <el-button type="primary" class="yl-button" @click="serach"
            >查询</el-button
          >
        </div>
        <div class="export">
          <el-button
            v-if="data == '1'"
            type="primary"
            class="yl-button"
            @click="exportData"
            >导出</el-button
          >
          <el-button type="primary" class="yl-button" @click="showSelectData"
            >选择</el-button
          >
        </div>
      </div>
      <!-- 历史趋势图 -->
      <div class="main" v-if="data == 0">
        <realDataCharts
          ref="mychild"
          width="100%"
          height="66vh"
          color="#fff"
          xycolor="#fff"
          :openTimer="false"
          timeUnit="m"
          :equipmentModel="stable"
          :List="List"
          :date="date"
          :serialNumber="serial_number"
          @AllNameData="AllNameData"
          @statusChange="statusChange"
          @getChecked="getChecked"
        />
      </div>
      <!-- 实时趋势图 -->
      <div class="main" v-if="data == 2">
        <realDataCharts
          ref="myRealTimeChild"
          width="100%"
          height="66vh"
          color="#fff"
          xycolor="#fff"
          :openTimer="true"
          timeUnit="s"
          :equipmentModel="stable"
          :List="List"
          :date="realTimeDate"
          :serialNumber="serial_number"
          @AllNameData="AllNameData"
          @statusChange="statusChange"
          @getChecked="getChecked"
        />
      </div>
      <div class="main" v-if="data == 1">
        <el-table stripe border :data="tableData">
          <el-table-column
            v-for="(item, key, index) in tableData[0]"
            :key="index"
            :label="key"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row[key] }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            :current-page="page"
            :page-size="size"
            :total="count"
            @current-change="changePage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="选择展示的数据"
      :visible.sync="showData"
      width="80%"
      @close="dialogClose"
    >
      <span class="formText">变量名称：</span>
      <el-input
        type="text"
        size="small"
        class="yl-input_noIcon w-258"
        @keyup.enter.native="serachData"
        placeholder="请输入变量名称"
        v-model="checkData"
      />
      <el-button
        type="primary"
        class="yl-button m20"
        size="small"
        @click="serachData"
        >查询</el-button
      >
      <el-checkbox
        class="checkbox"
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="handleCheckAllChange"
        >全选</el-checkbox
      >
      <el-checkbox-group
        v-model="checkList"
        @change="checkListChange"
        class="checkboxGroup"
      >
        <el-checkbox
          v-for="(item, index) in nameList"
          :key="index"
          :label="item.deviceVariables"
          class="checkbox"
          :style="item.isColour == 1 ? 'color:yellow' : ''"
          >{{ item.alias ? item.alias : item.deviceVariables }}</el-checkbox
        >
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="mini"
          class="yl-button"
          @click="submitNameData"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- <el-dialog title="选择变量名称" :visible.sync="showVariableName" width="80%">
      <el-radio v-model="variableName" v-for="(item,index) in nameList" :key="index" :label="item.name" class="checkbox">{{item.alias?item.alias:item.name}}</el-radio>
      <el-radio v-model="variableName" label="" class="checkbox">空</el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" class="yl-button" @click="showVariableName = false">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { utils } from "@/utils/index.js";
import realDataCharts from "@/components/realDataAll/realDatacharts";
import DataService from "@/api/data";
export default {
  components: {
    realDataCharts,
  },
  data() {
    return {
      stable: "",
      device_rank: "",
      checkData: "",
      time_interval: "0",
      realTimeDate: [], //实时数据的时间范围
      // showPage:true,
      checkAll: false,
      isIndeterminate: true,
      openTimer: true,
      data: "2",
      nameList: [],
      checkName: [],
      saveList: [], //打开选择变量弹窗时保存的checkList
      checkChange: 0, //0是变量选择取消，1是变量选择调取接口
      checkList: [], //多选选择的数据
      List: [],
      status: 0, //0代表默认参数，1代表修改
      // showVariableName:false,//显示选择变量弹窗
      showData: false, //多选数据弹窗
      serial_number: "",
      date: [], //日期开始结束数组
      page: 1,
      size: 10,
      count: 0,
      tableData: [],
      // variableName:'',//变量名
      // variableValue:'',//变量值
      equipmentModel: "",
    };
  },
  methods: {
    //模糊查询变量
    serachData() {
      DataService.queryTrendChartRequiredVariables({
        stable: this.stable,
        centrifugeLevel: this.device_rank,
        search: this.checkData,
      })
        .then((res) => {
          this.nameList = res.data;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    //导出历史数据
    exportData() {
      window.location.href =
        process.env.NODE_ENV === "development"
          ? `api/projectsite/exportTableHistoryData?user_id=${this.$store.state.user_id}&serialNumber=${this.serial_number}&equipmentModel=${this.stable}&startTime=${this.date[0]}&endTime=${this.date[1]}&timeUnit=m`
          : `${process.env.BASE_URL}/projectsite/exportTableHistoryData?user_id=${this.$store.state.user_id}&serialNumber=${this.serial_number}&equipmentModel=${this.stable}&startTime=${this.date[0]}&endTime=${this.date[1]}&timeUnit=m`;
    },
    time_intervalChange(val) {
      const endTime = utils.formatDate(new Date().getTime());
      switch (this.time_interval) {
        case "0":
          this.realTimeDate = [
            utils.formatDate(new Date().getTime() - 600000),
            endTime,
          ];
          break;
        case "1":
          this.realTimeDate = [
            utils.formatDate(new Date().getTime() - 3600000),
            endTime,
          ];
          break;
        case "2":
          this.realTimeDate = [
            utils.formatDate(new Date().getTime() - 7200000),
            endTime,
          ];
          break;
        case "3":
          this.realTimeDate = [
            utils.formatDate(new Date().getTime() - 10800000),
            endTime,
          ];
          break;
        case "4":
          this.realTimeDate = [
            utils.formatDate(new Date().getTime() - 14400000),
            endTime,
          ];
          break;
        case "5":
          this.realTimeDate = [
            utils.formatDate(new Date().getTime() - 28800000),
            endTime,
          ];
          break;
        case "6":
          this.realTimeDate = [
            utils.formatDate(new Date().getTime() - 43200000),
            endTime,
          ];
          break;
        default:
          break;
      }
      if (val) {
        this.serachCharts();
      }
    },
    handleCheckAllChange(val) {
      console.log(val);
      this.checkList = val ? this.checkName : [];
      this.isIndeterminate = false;
    },
    //弹窗关闭
    dialogClose() {
      if (this.checkChange == 0) {
        this.checkList = this.saveList;
      }
      this.openTimer = true;
    },
    //打开选择变量弹窗
    showSelectData() {
      this.checkData = "";
      this.serachData();
      this.saveList = this.checkList;
      this.showData = true;
      this.openTimer = false;
    },
    //获取默认时间
    showTime() {
      this.date = [];
      this.date.push(
        utils.formatDate(new Date().getTime() - 3600000),
        utils.formatDate(new Date())
      );
      this.realTimeDate = [
        utils.formatDate(new Date().getTime() - 600000),
        utils.formatDate(new Date()),
      ];
    },
    statusChange(status) {
      this.status = status;
    },
    getTableData(val) {
      if (val == "close") {
        this.page = 1;
        this.openTimer = false;
      }
      // let data = {
      //   variableName:this.variableName,
      //   variableValue:this.variableValue
      // }
      // Object.keys(data).map((item) => {
      //   if (data[item] === "") {
      //     delete data[item];
      //   }
      // });
      DataService.getTableHistoryData({
        list: this.checkList,
        status: this.status,
        user_id: this.$store.state.user_id,
        serialNumber: this.serial_number,
        page: this.page,
        size: this.size,
        startTime: this.date[0],
        endTime: this.date[1],
        equipmentModel: this.stable,
        timeUnit: "m",
        // ...data
      })
        .then((res) => {
          this.tableData = res.data.projectSiteList;
          this.count = res.data.count;
          this.showHistoryData = false;
          // this.showPage = true;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    //下拉选择变化
    selectChange() {
      this.status = 0;
      // this.showTime();
      if (this.data == "1") {
        this.openTimer = false;
        this.getTableData();
      } else if (this.data == "0") {
        this.openTimer = false;
        setTimeout(() => {
          this.$refs.mychild.getTrendChart();
        }, 500);
      } else {
        this.openTimer = true;
        setTimeout(() => {
          this.$refs.myRealTimeChild.getTrendChart();
        }, 500);
      }
    },
    changePage(page) {
      this.page = page;
      this.getTableData();
    },
    AllNameData(value) {
      this.nameList = value;
      this.checkName = [];
      this.nameList.forEach((el) => {
        this.checkName.push(el.deviceVariables);
      });
    },
    //获取已经选中的变量
    getChecked(array) {
      this.checkList = [];
      array.forEach((el) => {
        this.nameList.forEach((ele) => {
          if (el == ele.alias) {
            this.checkList.push(ele.deviceVariables);
          }
        });
      });
    },
    submitNameData() {
      this.status = 1;
      this.checkChange = 1;
      this.List = this.checkList;
      this.getTableData();
      this.showData = false;
    },
    checkListChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.nameList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.nameList.length;
    },
    serach() {
      if (this.data == "0") {
        this.serachCharts();
      } else {
        this.getTableData("close");
      }
    },
    serachCharts() {
      if (this.data == "0") {
        // this.openTimer = false;
        this.$refs.mychild.getTrendChart(false);
      } else {
        setTimeout(() => {
          this.$refs.myRealTimeChild.getTrendChart(false);
        }, 100);
      }
    },
  },
  created() {
    this.showTime();
    if (this.$route.query.serial_number) {
      this.serial_number = this.$route.query.serial_number;
      this.equipmentModel = this.$route.query.equipmentModel;
    }
    if (this.$route.query.device_rank) {
      this.device_rank = this.$route.query.device_rank;
      this.stable = this.$route.query.stable;
    }
  },
  mounted() {
    this.getTableData();
  },
  watch: {
    checkList() {
      console.log(this.checkList);
    },
  },
};
</script>
<style lang="scss" scoped>
.list_index {
  height: 100%;
  // background: url('https://yliiotcloud.obs.cn-east-3.myhuaweicloud.com/22631653358657_.pic_hd.jpg') no-repeat;
  background-size: 100% 100%;
}
h1 {
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  color: #fff;
}
.button {
  height: 60px;
  width: 100%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .date {
    display: flex;
    align-items: center;
    .el-button {
      margin-left: 10px;
    }
  }
}
.checkboxGroup {
  display: flex;
  flex-wrap: wrap;
}
.checkbox {
  width: 20%;
  color: #fff;
  display: block;
  margin-top: 10px;
}
.export {
  width: 200px;
  text-align: right;
}
</style>
